import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseSingleSelectColumnModel} from '../abstract/base-single-select'

export class StatusColumnModel extends BaseSingleSelectColumnModel {
  declare readonly id: typeof SystemColumnId.Status
  declare readonly dataType: typeof MemexColumnDataType.SingleSelect
  declare readonly userDefined: false
}
